import { render, staticRenderFns } from "./afterSubmit.vue?vue&type=template&id=024c15ee&scoped=true"
import script from "./afterSubmit.vue?vue&type=script&lang=js"
export * from "./afterSubmit.vue?vue&type=script&lang=js"
import style0 from "./afterSubmit.vue?vue&type=style&index=0&id=024c15ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024c15ee",
  null
  
)

export default component.exports